import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AlertsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/alerts/')({
  validateSearch: zodValidator(AlertsSearchSchema)
});